// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"e6c5f65a","264":"00dc0a5d","637":"39b6a5e7","684":"13f61fcf","686":"c04ef7e0","705":"d4fd60b5","718":"c1ca094f","791":"5339ed3d","880":"4016f366"}[chunkId] + ".chunk.js";
};